import React from 'react';
import { keyframes } from '@mui/system';
import {
  Close as CloseIcon,
  Check as CheckIcon,
  NewReleases as NewReleasesIcon,
  Chat as ChatIcon,
  Payment as PaymentIcon,
  Sync as SyncIcon,
} from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getNames } from 'country-list';
import currencyCodes from 'currency-codes';

export const countriesList = getNames();
export const currencies = currencyCodes.codes();

export const services = [
  'Email Campaigns',
  'SMS Campaigns',
  'Google Ads',
  'Facebook Ads',
  'VK Ads',
  'SEO',
];

export const objectives = [
  'Increase sales',
  'Attract new customers',
  'Increase brand awareness',
  'Drive more website traffic',
  'Generate leads',
  'Promote a new product or service',
  'Engage the audience',
  'Promote special offers or discounts',
  'Grow subscribers',
  'Improve customer retention',
  'Collect feedback',
  'Improve conversion rates',
  'Retargeting',
];

export const ageRanges = ['18-24', '25-34', '35-44', '45-54', '55-64', '65+'];
export const genders = ['Male', 'Female', 'All'];
export const contactDatabases = ['I have my own database', 'Use the agency database'];

export const emptyFormData = {
  firstName: '',
  lastName: '',
  companyName: '',
  phoneNumber: '',
  email: '',
  projectName: '',
  chosenService: '',
  status: '',
  serviceSelection: '',
  campaignObjective: '',
  countries: [],
  cities: [],
  ageRange: [],
  gender: '',
  keywords: '',
  approximateBudget: '',
  currency: '',
  targetAudienceDescription: '',
  contactDatabase: '',
  additionalMessage: '',
  graphicService: '',
  graphicDescription: '',
  graphicWebsite1: '',
  graphicWebsite2: '',
  graphicWebsite3: '',
  graphicFiles: [],
  seoWebpage: '',
  seoDescription: '',
  webDevMessage: '',
  webDevWebsite1: '',
  webDevWebsite2: '',
  webDevWebsite3: '',
  webDevFiles: [],
  businessMessage: '',
  businessWebsite1: '',
  businessWebsite2: '',
  businessWebsite3: '',
  businessFiles: [],
  privacyPolicyAgreed: false,
  price: '',
  projectDeadline: null,
  paidAt: null,
};

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;

const bounceAnimation = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
`;

const glowAnimation = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

export const statusOptions = [
  {
    value: 'New',
    label: 'New',
    icon: (
      <NewReleasesIcon
        fontSize="small"
        sx={{
          animation: `${pulseAnimation} 1.5s ease-in-out infinite`,
          color: '#ff9800',
        }}
      />
    ),
  },
  {
    value: 'Pending',
    label: 'Pending',
    icon: (
      <NewReleasesIcon
        fontSize="small"
        sx={{
          animation: `${glowAnimation} 2s ease-in-out infinite`,
          color: '#2196f3',
        }}
      />
    ),
  },
  {
    value: 'Communication',
    label: 'Communication',
    icon: (
      <ChatIcon
        fontSize="small"
        sx={{
          animation: `${bounceAnimation} 1s ease-in-out infinite`,
          color: '#4caf50',
        }}
      />
    ),
  },
  {
    value: 'Pending payment',
    label: 'Pending payment',
    icon: (
      <PaymentIcon
        fontSize="small"
        sx={{
          animation: `${pulseAnimation} 2s ease-in-out infinite`,
          color: '#f44336',
        }}
      />
    ),
  },
  {
    value: 'In processing',
    label: 'In processing',
    icon: (
      <SyncIcon
        fontSize="small"
        sx={{
          animation: `${rotateAnimation} 2s linear infinite`,
          color: '#9c27b0',
        }}
      />
    ),
  },
  {
    value: 'Closed',
    label: 'Closed',
    icon: <CheckIcon fontSize="small" sx={{ color: '#4caf50' }} />,
  },
];

export const statusColors = {
  New: {
    background: 'rgba(255, 152, 0, 0.1)',
    text: '#d97706',
  },
  Pending: {
    background: 'rgba(33, 150, 243, 0.1)',
    text: '#1976d2',
  },
  Communication: {
    background: 'rgba(76, 175, 80, 0.1)',
    text: '#2e7d32',
  },
  'Pending payment': {
    background: 'rgba(244, 67, 54, 0.1)',
    text: '#d32f2f',
  },
  'In processing': {
    background: 'rgba(156, 39, 176, 0.1)',
    text: '#7b1fa2',
  },
  Closed: {
    background: 'rgba(158, 158, 158, 0.1)',
    text: '#424242',
  },
};

export const paymentStatusOptions = [
  {
    value: 'Waiting',
    label: 'Waiting',
    icon: (
      <PaymentIcon
        fontSize="small"
        sx={{
          animation: `${pulseAnimation} 2s ease-in-out infinite`,
          color: '#ed6c02',
        }}
      />
    ),
  },
  {
    value: 'Processing',
    label: 'Processing',
    icon: (
      <SyncIcon
        fontSize="small"
        sx={{
          animation: `${rotateAnimation} 2s linear infinite`,
          color: '#0288d1',
        }}
      />
    ),
  },
  {
    value: 'Paid',
    label: 'Paid',
    icon: (
      <CheckCircleIcon
        fontSize="small"
        sx={{
          animation: `${bounceAnimation} 1s ease-in-out infinite`,
          color: '#2e7d32',
        }}
      />
    ),
  },
  {
    value: 'Failed',
    label: 'Failed',
    icon: (
      <CloseIcon
        fontSize="small"
        sx={{
          animation: `${glowAnimation} 2s ease-in-out infinite`,
          color: '#d32f2f',
        }}
      />
    ),
  },
];
